<yds-modal [open]="open()" [title]="title()" size="md" (close)="onCancel()">
  <form class="erd-form" [formGroup]="form">
    <p class="gl-form__required-hint">
      Velden gemarkeerd met een sterretje
      (<span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>) zijn verplicht
    </p>

    <div class="gl-field">
      <label class="gl-field__label">
        <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Regelomschrijving
      </label>
      <div class="gl-field__control">
        <yds-text-field
          formControlName="exportRuleName"
          [required]="true"
          [maxLength]="50"
          [hasError]="isInvalid(form.get('exportRuleName'))"
          [errorMsg]="'Regelomschrijving is verplicht.'"
          [placeholder]="'Vul een regelomschrijving in'"
        />
      </div>
    </div>

    <div class="gl-field">
      <label class="gl-field__label">
        <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Soort regel
      </label>
      <div class="gl-field__control">
        <yds-radio-group
          formControlName="kindOfExportLine"
          [items]="kindRadioOptions()"
          [hasError]="validationTriggered() && !form.get('kindOfExportLine')?.value"
          [errorMsg]="
            validationTriggered() && !form.get('kindOfExportLine')?.value
              ? 'Selecteer een soort regel.'
              : null
          "
        />
      </div>
    </div>

    <div class="gl-field">
      <label class="gl-field__label">Niveau kopregel</label>
      <div class="gl-field__control">
        <yds-dropdown
          formControlName="headerLevel"
          [items]="headerLevelDropdownOptions()"
          [allowClear]="false"
          [placeholder]="'Selecteer niveau kopregel'"
        />
      </div>
    </div>

    <div class="erd-checkboxes">
      <yds-checkbox
        formControlName="applyItemSeparator"
        [label]="'Toepassen rubriekscheidingsteken'"
      />
      <yds-checkbox
        formControlName="applyLineSeparator"
        [label]="'Toepassen regelscheidingsteken'"
      />
    </div>
  </form>

  <div footer class="erd-footer">
    <yds-button variant="default" (click)="onCancel()">Annuleren</yds-button>
    <yds-button variant="primary" [disabled]="isSaving()" (click)="onSave()">
      {{ isEditMode() ? 'Opslaan' : 'Toevoegen' }}
    </yds-button>
  </div>
</yds-modal>
